import { CircularProgress } from '@mui/material';
import React from 'react';

import * as Styled from './goal-template-form-loading.style';

export const GoalTemplateFormLoading: React.FC = () => (
  <Styled.Container>
    <CircularProgress />
  </Styled.Container>
);
